import { render, staticRenderFns } from "./echartest.vue?vue&type=template&id=61c8ba58&scoped=true&"
import script from "./echartest.vue?vue&type=script&lang=js&"
export * from "./echartest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8ba58",
  null
  
)

export default component.exports